var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-overlay',{attrs:{"show":_vm.posts === null,"rounded":"sm"}},[_c('b-row',[_c('b-col',{staticClass:"mx-auto",attrs:{"cols":"12"}},[_c('profile-post',{attrs:{"posts":_vm.posts}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }